import React, {ClassAttributes, InputHTMLAttributes} from 'react';
import {FieldHookConfig, useField} from "formik";
import {Option, SingleCombobox} from "../Control";
import FieldHelp from "./FieldHelp";

// Component ----

type CustomProps = {
  options: Array<Option>
  label?: string
  hint?: string
  help?: string
  onSearch?: (searchTerm?: string) => void
  onChange?: (option: Option | null) => void
  isLoading?: boolean
  disabled?: boolean
  required?: boolean
}

export type SelectFieldProps = InputHTMLAttributes<HTMLInputElement>
  & ClassAttributes<HTMLSelectElement>
  & FieldHookConfig<string>
  & CustomProps

function SelectField({options, label, hint, help, onSearch, onChange, isLoading, disabled, required, ...props}: SelectFieldProps) {
  const [field, meta, {setValue}] = useField(props)

  const handleChange = (option: Option | null) => {
    onChange && onChange(option);
    void setValue(option?.id?.toString() ?? '')
  }

  // Error state
  const hasError = meta.touched && !!meta.error

  // Preselected options
  const selectedOption = options.find(option => option.id?.toString() === field.value?.toString())

  return (
    <div>
      {/* Combo box */}
      <SingleCombobox
        label={label}
        hint={hint}
        options={options}
        selected={selectedOption}
        onSearch={onSearch}
        onChange={handleChange}
        isLoading={isLoading}
        disabled={disabled}
        required={required}
      />

      {/* Help text or error message */}
      {(!!help || hasError) &&
        <FieldHelp isError={hasError}>
          {hasError ? meta.error : help}
        </FieldHelp>
      }
    </div>
  )
}

export default SelectField;